"use client"

import Image from "next/image"
import { cn } from "@/lib/utils"

interface RudriseLogoProps {
  size?: "sm" | "md" | "lg" | "xl"
  showText?: boolean
  className?: string
  /** Fully replaces or augments the default classes on the "Rudrise" text. */
  textClassName?: string
}

export function RudriseLogo({ size = "md", showText = true, className, textClassName }: RudriseLogoProps) {
  const sizeClasses = {
    sm: { icon: 30, text: "text-xl" },
    md: { icon: 40, text: "text-2xl" },
    lg: { icon: 50, text: "text-4xl" },
    xl: { icon: 60, text: "text-6xl" },
  }

  const iconSize = sizeClasses[size].icon
  const iconHeight = Math.round(iconSize * 4.5) // Maintain aspect ratio (46/39 ≈ 1.18)

  return (
      <div className={cn("flex items-center gap-2", className)}>
        <Image
            src="/rudrise-logo.svg"
            alt="Rudrise Logo"
            width={iconSize}
            height={iconHeight}
            priority
        />
        {showText && (
            <span
                className={cn(
                    "flex items-center font-normal text-[var(--db-user-header)]",
                    sizeClasses[size].text,
                    textClassName
                )}
                style={{ color: "var(--db-user-header)" }} // Guarantees color applies even if Tailwind purges the arbitrary class or CSS variable scope is delayed
            >
          Rudrise
        </span>
        )}
      </div>
  )
}